module.exports = __webpack_public_path__ + "assets/img/icon1.8cd5d514.svg";